/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

export function TextFieldViewer(props) {
	const {Value} = props;

	return Value != null ? Value : "";
}